import { render, staticRenderFns } from "./NumberManagementService.vue?vue&type=template&id=454eb3fc&scoped=true&"
import script from "./NumberManagementService.vue?vue&type=script&lang=js&"
export * from "./NumberManagementService.vue?vue&type=script&lang=js&"
import style0 from "./NumberManagementService.vue?vue&type=style&index=0&id=454eb3fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454eb3fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSimpleTable,VTextField,VTooltip})
